var _mask, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackButtonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5L1 8L5 11L5 9L15 9L15 7L5 7L5 5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5L1 8L5 11L5 9L15 9L15 7L5 7L5 5Z",
    fill: "#EF3340"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8L0.399999 7.2L-0.666667 8L0.399999 8.8L1 8ZM5 5L6 5L6 3L4.4 4.2L5 5ZM5 11L4.4 11.8L6 13L6 11L5 11ZM5 9L5 8L4 8L4 9L5 9ZM15 9L15 10L16 10L16 9L15 9ZM15 7L16 7L16 6L15 6L15 7ZM5 7L4 7L4 8L5 8L5 7ZM1.6 8.8L5.6 5.8L4.4 4.2L0.399999 7.2L1.6 8.8ZM5.6 10.2L1.6 7.2L0.399999 8.8L4.4 11.8L5.6 10.2ZM4 9L4 11L6 11L6 9L4 9ZM15 8L5 8L5 10L15 10L15 8ZM14 7L14 9L16 9L16 7L14 7ZM5 8L15 8L15 6L5 6L5 8ZM4 5L4 7L6 7L6 5L4 5Z",
    fill: "#EF3340",
    mask: "url(#path-1-inside-1)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButtonIcon);
export default __webpack_public_path__ + "static/media/back-button-icon.78224ee1049969f914bcd86940ed03a9.svg";
export { ForwardRef as ReactComponent };